import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { HandleThreeDSChallengeOutcomeRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { HandleThreeDSChallengeOutcomeResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const handleThreeDSChallengeOutcome = (
  request: HandleThreeDSChallengeOutcomeRequest,
  options?: CashRequestOptions
) =>
  post<HandleThreeDSChallengeOutcomeRequest, HandleThreeDSChallengeOutcomeResponse>(
    '/2.0/cash/handle-three-d-s-challenge-outcome',
    request,
    { ...options, rejectOnError: true }
  )
